import { useLayoutEffect, useMemo, useRef } from 'react'
import type { ContentLang } from '@/features/editor/editorSlice'
import { sampleDesignElement } from '@/features/editor/lib/designElementSamples'
import { useHoveredDesignElement } from '@/features/editor/lib/designHoverPreview'
import { DesignElementView } from './DesignElementView'

const noop = () => {}

/**
 * Примерка: элемент того типа, на который автор навёл мышь в панели, —
 * с примерными данными, полупрозрачный, без рамки и кликов. В черновик
 * не попадает.
 */
export const DesignGhostElement = ({ contentLang }: { contentLang: ContentLang }) => {
  const type = useHoveredDesignElement()
  const element = useMemo(() => (type ? sampleDesignElement(type) : null), [type])
  const ref = useRef<HTMLDivElement>(null)
  // На длинном блоке примерка встаёт ниже видимой части — за прилипшей строкой «+».
  // Прокручиваем холст до конца: элементы уезжают вверх, примерка встаёт прямо над
  // строкой типов. Строка прилипла к низу, поэтому курсор с типа не слетает.
  useLayoutEffect(() => {
    const canvas = ref.current?.closest<HTMLElement>('[data-design-canvas]')
    if (canvas) canvas.scrollTop = canvas.scrollHeight
  }, [element])
  if (!element) return null
  return (
    // Отступ — паддингом, а не `mt-*`: `space-y-*` списка перебил бы margin.
    <div
      ref={ref}
      aria-hidden
      data-design-chrome
      data-testid="design-ghost-element"
      className="pointer-events-none rounded-lg pt-4 opacity-60 duration-200 animate-in fade-in"
    >
      <DesignElementView
        element={element}
        editable={false}
        contentLang={contentLang}
        isRun={false}
        onSelect={noop}
        onUpdate={noop}
      />
    </div>
  )
}
